import axios from "axios";

export function SetDealerUpdateStatus({
  id,
  status,
}) {
  const url = `/distributor/admin/api/v1/dealers/${id}/update-status`;

  return new Promise((resolve, reject) => {
    axios.post(url, {
      status: status,
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}